export default __webpack_public_path__ + "static/media/visa.3ae59ee5.png";